import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommonService } from '../shared/service/common.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  aboutUS: SafeHtml;
  imageBaseUrl: string = environment.imageBaseUrl;
  constructor(private sanitizer: DomSanitizer, private kesaviService: CommonService) { }

  ngOnInit() {
    this.getAboutUS();
  }

  getAboutUS() {
    this.kesaviService
      .getAboutUs()
      .then((result) => {
        this.aboutUS = this.sanitizer.bypassSecurityTrustHtml(result[0].Description);
      })
      .catch((err) => { console.log(err) });
  }

}
